<div class="box-conditional-offer-bid" *ngIf="vehicle.isConditionalOffer && vehicle.ownsCurrentBid && vehicle.conditionalOffer?.counterOffer?.status !== 'WAITING'">
  <div class="row">
    <div class="col-md-2">
      <i class="fa-solid fa-exclamation-circle" style="font-size: 39px; color: #f5882f"></i>
    </div>
    <div class="col-md-10 pl-4">
      <div class="row">
        <span class="title">Oferta em avaliação</span>
      </div>
      <div class="row">
        <span class="subtitle">Sua oferta foi encaminhada para o anunciante.</span>
      </div>
    </div>
  </div>
</div>
<div class="box-conditional-offer" *ngIf="vehicle.isConditionalOffer && !vehicle.ownsCurrentBid">
  <div class="row">
    <div class="col-md-2">
      <i class="fa-solid fa-exclamation-circle" style="font-size: 39px"></i>
    </div>
    <div class="col-md-10 title-box-offer">
      <span>Oferta condicional</span>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-md-12">
      <span style="font-weight: 400">A oferta para este veículo é condicional e será confirmada após a aprovação do
        anunciante.</span>
    </div>
  </div>
</div>
 
<div class="box-contra-proposta" *ngIf="vehicle.conditionalOffer?.counterOffer?.status === 'WAITING'">
  <div class="row">
    <div class="col-md-12">
      <div class="title-box">CONTRA PROPOSTA RECEBIDA</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 value">
      <span class="currency-symbol">R$&nbsp;</span>
      {{ vehicle.conditionalOffer.counterOffer.value | number }}
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 disclaimer">
      Ao aceitar esta contra proposta, você estará automaticamente fazendo uma oferta de R$
      {{ vehicle.conditionalOffer.counterOffer.value | number }} neste veículo. Sua oferta original era de R$
      {{ vehicle.conditionalOffer.bid | number }}.
    </div>
  </div>
  <div class="row mt-3" *ngIf="vehicle.conditionalOffer.counterOffer.message">
    <div class="col-md-12">
      <label class="message">Mensagem recebida</label>
      <div class="messageContainer">
        {{ vehicle.conditionalOffer.counterOffer.message.length > 250 ? (vehicle.conditionalOffer.counterOffer.message | slice:0:250) + '...' : vehicle.conditionalOffer.counterOffer.message }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 warning-box" *ngIf="counterOfferErrorMessage">
      <i class="material-icons">warning</i>
      {{ counterOfferErrorMessage }}
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button class="btn btn-primary btn-rounded btn-block text-white"
        (click)="acceptConditionalCounterOffer(); $event.stopPropagation()">ACEITAR CONTRA PROPOSTA</button>
      <button class="btn btn-danger btn-rounded btn-block mt-2"
        (click)="rejectConditionalCounterOffer(); $event.stopPropagation()">REJEITAR</button>
    </div>
  </div>
</div>

<div class="box-bid"
  *ngIf="!vehicle.ownsCurrentBid && (vehicle.bidOption !== 'ONLY_FINAL_BID' || layoutVars?.transactional)"
  (click)="$event.preventDefault()">
  <div class="row">
    <div class="col-md-12">
      <div class="title-box">
        <div class="icon-circle">
          <i class="fa-solid fa-tag fa-rotate-90"></i>
        </div>
        <span class="title">FAZER UMA OFERTA</span>
      </div>
    </div>
    <div class="col-md-12 bid-error-message" *ngIf="bidErrorMessage">
      Houve um problema com a sua oferta:<br />
      {{ bidErrorMessage }}
      <ng-container *ngIf="showLatePaymentLink"><a [routerLink]="['/arrematar/arrematados']"
          [queryParams]="latePaymentQueryParams">Veja aqui</a> seus veículos com fee plataforma
        pendente.</ng-container>
    </div>
    <div class="col-md-12 value">
      <mat-form-field>
        <span matPrefix class="currency-symbol">R$&nbsp;</span>
        <input matInput currencyMask [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
          type="tel" [(ngModel)]="bidValue" (ngModelChange)="clearBidError()"
          (click)="$event.stopPropagation(); $event.preventDefault()" />
        <mat-icon matSuffix style="font-size: 24px"
          [style.color]="layoutVars ? layoutVars.primaryColor : '#fff'">mode_edit</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-12 button-group" *ngIf="user && user.isDealer()">
      <button class="btn btn-outline-white btn-rounded btn-bg" [style.backgroundColor]=""
        style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(1); $event.stopPropagation(); $event.preventDefault()">
        <i class="material-icons">add</i>{{ vehicle.bidStep | number }}
      </button>
      <button class="btn btn-outline-white btn-rounded ml-2 btn-bg" style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(2); $event.stopPropagation(); $event.preventDefault()">
        <i class="material-icons">add</i>{{ vehicle.bidStep * 2 | number }}
      </button>
      <button class="btn btn-outline-white btn-rounded ml-2 btn-bg" style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(3); $event.stopPropagation(); $event.preventDefault()">
        <i class="material-icons">add</i>{{ vehicle.bidStep * 3 | number }}
      </button>
    </div>

    <div class="col-md-12" [ngClass]="{ 'mt-4': user?.isDealer() }">
      <div class="description" *ngIf="disableConfirmationModal && !fromCard && calculateCommissionValue() > 0">
        <div class="value-info">
          <div class="row">
            <span style="color: #828282; font-weight: 400;">Valor da oferta:</span>
            <span>R$ {{ bidValue | number:'1.2-2' }}</span>
          </div>
          <div class="row">
            <span style="color: #828282; font-weight: 400;">Fee plataforma:</span>
            <span>R$ {{ calculateCommissionValue() | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="total-estimate">
          <strong>Total estimado da operação:</strong>
          <span class="estimated-value">R$ {{ calculateTotalOperation() | number:'1.2-2' }}</span>
          <small class="observation">O valor da fee da plataforma é estimado e só será cobrado caso o veículo seja comprado.</small>
        </div>
      </div>

      @if (isMobile && user?.dealerFloorPlanEnabled) {
      <div class="floorplan-container mt-2 mb-4">
          <div class="new-tag">
            <span>NOVO</span>
            <i class="fa-solid fa-star"></i>
          </div>
          <div class="floorplan-title-info">
            <i class="fa-solid fa-lightbulb fa-bounce"></i>
            <div class="d-flex flex-column gap-1">
              <span class="title-floorplan">Linha de crédito disponível</span>
              <div class="info-text">
                Se você vencer a disputa, poderá usar seu limite Auto Arremate para pagar em até 90 dias.
              </div>
            </div>
          </div>
        </div>
      }

      <button class="btn btn-primary btn-rounded btn-block" style="height: 48px"
        (click)="disableConfirmationModal ? makeABid(false) : openModal(); $event.stopPropagation(); $event.preventDefault()">
        FAÇA SUA OFERTA
      </button>

      @if (isMobile) {
      <button class="btn btn-alternative btn-rounded btn-block mt-2" style="height: 48px"
        (click)="triggerAlternativeBid(); $event.stopPropagation(); $event.preventDefault()">
        PENSOU EM OUTRO VALOR?
      </button>
      }

    </div>

    <div class="col-md-12 d-flex automatic-bid" *ngIf="user?.isDealer()">
      <i class="admin-icon-balao-dolar" style="margin-right: 8px"></i>
      <span class="label">Oferta automática</span>
      <i class="material-icons" style="margin-left: 10px" [matTooltip]="automaticBidInfo"
        [matTooltipClass]="'tooltip-class'">info</i>

      <label class="switch" style="margin-left: rem" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="showAutomaticBid" />
        <span class="slider round"></span>
      </label>
    </div>
    <div class="col-md-12 d-flex automatic-bid-input" *ngIf="showAutomaticBid && user?.isDealer()">
      <div class="input-group">
        <mat-form-field>
          <span matPrefix class="currency-symbol">R$&nbsp;</span>
          <input class="price-input" matInput currencyMask
            [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }" type="tel"
            [(ngModel)]="automaticBidValue" (click)="$event.stopPropagation()" />
        </mat-form-field>
      </div>
      <button class="btn btn-rounded confirm-button" (click)="makeABid(true)" [disabled]="loading">CONFIRMAR</button>
    </div>
    <div class="col-md-12 d-flex stats mt-0 mb-3" *ngIf="showAutomaticBid">
      A oferta automática pode ser desativada a qualquer momento, mantendo sua última oferta como a oferta atual.
    </div>

    <div class="col-md-12 mt-3" *ngIf="user?.isDealer()">
      <mat-divider></mat-divider>
    </div>

    <div class="col-md-12 text-center stats mt-2" *ngIf="vehicle.views && user?.isDealer()">
      <i class="material-icons">remove_red_eye</i> {{ vehicle.views | number }}
      <span *ngIf="vehicle.views > 1">&nbsp;pessoas já viram&nbsp;</span>
      <span *ngIf="vehicle.views <= 1">&nbsp;pessoa já viu&nbsp;</span>
      esse veículo
    </div>

    <div class="col-md-12 text-center stats"
      *ngIf="vehicle.currentBidDealerName && !vehicle.ownsCurrentBid && user?.isDealer() && user?.isAdmin()">
      <i class="app-icon-tag" style="margin-right: 4px"></i>
      <span>Oferta atual de:&nbsp;</span> {{ vehicle.currentBidDealerName }}
    </div>
  </div>
</div>

<div class="box-owns-current-bid" *ngIf="vehicle.ownsCurrentBid">
  <div class="contents-box">
    <div class="title-box">
      <i class="app-icon-tag" style="margin-right: 8px"></i>
      Sua última oferta
    </div>
    <div class="value">R$ {{ vehicle.currentPrice | number }}</div>
    <div class="warning">
      <i class="material-icons">check_circle</i>
      Você está arrematando
    </div>
    <button class="cancel-bid-link btn btn-link mt-2" (click)="openCancelBidModal()"
      *ngIf="vehicle.canCancelBid">Cancelar oferta</button>
  </div>

  <div class="col-md-12 text-center stats" *ngIf="vehicle.views">
    <i class="material-icons">remove_red_eye</i>{{ vehicle.views | number }}
    <span *ngIf="vehicle.views > 1">&nbsp;pessoas já viram&nbsp;</span>
    <span *ngIf="vehicle.views <= 1">&nbsp;pessoa já viu&nbsp;</span>
    esse veículo
  </div>
</div>
<!-- CARD OFERTA AUTOMATICA ABAIXO DA VISUALIZAÇÃO DA OFERTA-->
<div class="box-bid-automatic-info" *ngIf="vehicle.ownsCurrentBid && vehicle.enabledAutomaticBid">
  <div class="col-md-12 d-flex automatic-bid mt-0">
    <i class="admin-icon-balao-dolar" style="margin-right: 8px"></i>
    <span class="label">Oferta automática</span>
    <label class="switch" style="margin-left: 6rem">
      <input type="checkbox" [checked]="vehicle.enabledAutomaticBid" (click)="disableAutomaticBid($event)" />
      <span class="slider round"></span>
    </label>
  </div>
  <div class="col-md-12">
    <span class="label">Habilitado para cobrir ofertas de até: <span class="value">{{ automaticBidValue - 1 | currency :
        "BRL" : "symbol" : "1.0-0" }}</span></span>
  </div>
</div>

<!-- MODAL -->
<div class="modal-backdrop fade in" [style.display]="showModal ? 'block' : 'none'"></div>
<div class="modal fade" [ngClass]="{ show: showModal, hide: !showModal }"
  [style.display]="showModal ? 'block' : 'none'" (click)="closeModal()">
  <div class="modal-dialog modal-dialog-centered justify-content-center" (click)="(false); $event.stopPropagation()">
    <div class="modal-content box-modal-bid">
      <ng-container *ngIf="canBid()">
        <div class="modal-header">
          <div class="title-box">
            <i class="fa-solid fa-tag fa-rotate-90"></i>
            <span class="title">Confirmar oferta</span>
          </div>
          <i class="fa-regular fa-xmark close-button" (click)="closeModal()"></i>
        </div>
        <div class="modal-body">
          <div class="main-value">
            R$ {{ bidValue | number }}
          </div>

          <div class="value-info" *ngIf="calculateCommissionValue() > 0">
            <div class="row">
              <span class="offer-value">Valor da oferta:</span>
              <span class="offer-value-amount">R$ {{ bidValue | number:'1.2-2' }}</span>
            </div>
            <div class="row">
              <span class="platform-fee">Fee plataforma:</span>
              <span class="platform-fee-amount">R$ {{ calculateCommissionValue() | number:'1.2-2' }}</span>
            </div>
          </div>

          <div class="total-estimate" *ngIf="calculateCommissionValue() > 0">
            <strong>Total estimado da operação:</strong>
            <span class="estimated-value">R$ {{ calculateTotalOperation() | number:'1.2-2' }}</span>
            <small class="observation">O valor da fee da plataforma é estimado e só será cobrado caso o veículo seja comprado.</small>
          </div>
        </div>

        @if (user?.dealerFloorPlanEnabled) {
        <div class="floorplan-container mt-2 mb-4">
          <div class="new-tag">
            <span>NOVO</span>
            <i class="fa-solid fa-star"></i>
          </div>
          <div class="floorplan-title-info">
            <i class="fa-solid fa-lightbulb fa-bounce"></i>
            <div class="d-flex flex-column gap-1">
              <span class="title-floorplan">Linha de crédito disponível</span>
              <div class="info-text">
                Se você vencer a disputa, poderá usar seu limite Auto Arremate para pagar em até 90 dias.
              </div>
            </div>
          </div>
        </div>
        }

        <div class="modal-footer" *ngIf="!bidErrorMessage">
          <button class="confirm-button" (click)="makeABid(false)">Confirmar oferta</button>
          <div class="description">
            {{ vehicle.isConditionalOffer ? conditionalOfferInfo : defaultOfferInfo }}
          <span>{{ vehicle.expirationDate | date:'dd/MM/yyyy' }}</span> às <span>{{ vehicle.expirationDate | date:'HH:mm' }}.</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!canBid()">
        <app-access-account-modal-body (closeModal)="closeModal()"></app-access-account-modal-body>
      </ng-container>
    </div>
  </div>
</div>